import React from "react";
import styled from "styled-components";
import propTypes from "prop-types";
import "./loader.css";

const LoaderView = styled.section`
   width: 100%;
   height: 100vh;
   background-color: rgba(10, 10, 10, 0.9);
   position: fixed;
   top: 0;
   left: 0;
   bottom: 0;
   right: 0;
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 10000000000000000000;

   & p {
      color: white;
      text-align: center;
   }
`;

const AppLoader = ({isVisible}) => {
   if (!isVisible) return null;
   return (
      <LoaderView>
         <div className="preloader">
            <div className="loader__figure"></div>
         </div>
      </LoaderView>
   );
};

export default AppLoader;

AppLoader.defaultProps = {
   isVisible: false,
};
AppLoader.propTypes = {
   isVisible: propTypes.bool,
};

export const LoadComponet = ({isVisible}) => {
   if (!isVisible) return null;
   return (
      <LoadComponetStyled>
         <div className="preloader">
            <div className="loader__figure"></div>
         </div>
      </LoadComponetStyled>
   );
};

LoadComponet.defaultProps = {
   isVisible: true,
};

const LoadComponetStyled = styled.div`
   padding: 2em 0;
   display: flex;
   justify-content: center;
   align-items: center;
   position: relative;

   & p {
      color: white;
      text-align: center;
   }

   .preloader {
      .loader__figure {
         border-color: ${(props) => props.back};
      }
      .loader__label {
         color: ${(props) => props.back};
      }
   }
`;

export const StatusLoader = ({isVisible, status}) => {
   if (!isVisible) return null;
   return (
      <LoaderView>
         <div className="preloader">
            <div className="loader__figure"></div>
            <p>{status || "cargando"}</p>
         </div>
      </LoaderView>
   );
};
